export const RECEIVE_USERLIST = 'receive_userList'
export const RECEIVE_PLATELIST = 'receive_plateList'
export const RECEIVE_PLATENAMES = 'receive_plateNames'
export const RECEIVE_PLATEUSERPLATELIST = 'receive_plateUserPlateList'
export const RECEIVE_COMMONLIST = 'receive_commonList'
export const RECEIVE_PLATEUSERCOMMONLIST = 'receive_plateUserCommonList'
export const RECEIVE_ARTICLELIST = 'receive_articleList'
export const RECEIVE_PLATEUSERARTICLELIST = 'receive_plateUserArticleList'
export const RECEIVE_LOGINUSER = 'receive_loginUser'
export const RECORD_USERID = 'record_userId'

export const RECEIVE_TOPLATEUSER = 'receive_toPlateUser'
// export const DElETE_PLATE = 'delete_plate'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js